import type { TiersPricing } from '@vy/types';
import { safeDivision } from '@vy/utils';

export function getRateMultiplierAdjustedTiersPricing(
  pricing: TiersPricing,
  rateMultiplier: number,
): TiersPricing {
  const {
    priceConfiguration: { tiers },
  } = pricing;

  return {
    ...pricing,
    priceConfiguration: {
      ...pricing.priceConfiguration,
      tiers: tiers.map((tier) => ({
        ...tier,
        price: safeDivision(tier.price, rateMultiplier),
      })),
    },
  };
}
